import React, { useMemo, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useStaticOptions } from "../context/StaticOptionsContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { IconHexagon5 } from "@tabler/icons-react";

const mapMidsoleColor = (item, index) => {
    const value = String(
        item?.midsole_color_szam ??
            item?.midsole_color_id ??
            item?.value ??
            index
    );

    const label =
        (item && item.rmelimidsolecolors_sole_color_national) || "Ismeretlen";

    const soleColorId =
        item && item.rmelimidsolecolors_sole_color_id != null
            ? item.rmelimidsolecolors_sole_color_id
            : null;

    return { value, label, soleColorId };
};

const Koztalp = () => {
    const { order, updateOrder } = useOrder();
    const navigate = useStepNavigate();
    const { staticOptions } = useStaticOptions();

    const colors = useMemo(function () {
        const list = (staticOptions && staticOptions.midsole_colors) || [];
        return list
            .map(mapMidsoleColor)
            .filter(function (c) {
                return c.value !== "" && c.label !== "";
            })
            .sort(function (a, b) {
                return a.label.localeCompare(b.label, "hu");
            });
    }, [staticOptions]);

    const [selectedColor, setSelectedColor] = useState(
        order.koztalp_color_temp ? String(order.koztalp_color_temp) : ""
    );

    const handleColorSelect = function (color) {
        const nextValue = color.value;
        const nextLabel = color.label;

        setSelectedColor(nextValue);
        updateOrder({
            ...order,
            koztalp_color_temp: nextValue,
            koztalp_color_temp_name: nextLabel,
            koztalp_sole_color_id_temp: color.soleColorId
        });
    };

    const handleBack = function () {
        navigate("/Talp");
    };

    const handleNext = function () {
        navigate("/Rama");
    };

    const canProceed = Boolean(selectedColor);

    return (
        <TablerLayout title="Köztalp szín kiválasztása">
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="mb-4">
                        <h5 className="text-lg font-semibold mb-2">
                            Kérem adja meg a választani kívánt köztalp színét
                        </h5>
                    </div>

                    <div className="card-body">
                        {colors.length === 0 ? (
                            <div className="alert alert-warning mb-0">
                                Nem érkezett köztalp szín adat a midsole_colors listából.
                            </div>
                        ) : (
                            <div className="row g-3">
                                {colors.map(function (color) {
                                    const isSelected = selectedColor === color.value;

                                    return (
                                        <div className="col-12 col-sm-6 col-md-4" key={color.value}>
                                            <button
                                                type="button"
                                                className={
                                                    "btn w-100 py-3 fw-semibold " +
                                                    (isSelected ? "btn-primary" : "btn-outline-primary text-primary border-primary bg-white")
                                                }
                                                style={{
                                                fontSize: 18,
                                                fontWeight: 600,
                                                borderWidth: 2,
                                                minHeight: 60,
                                                }}
                                                onClick={function () {
                                                    handleColorSelect(color);
                                                }}
                                            >
                                                {color.label}
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton side="left" label="Vissza" onClick={handleBack} />
                        <StepperNavButton
                            side="right"
                            label="Tovább"
                            onClick={handleNext}
                            disabled={!canProceed}
                        />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default Koztalp;